// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   1. Typography & Base Settings
   ========================================= */
.client-side-datatable .ag-cell,
.client-side-datatable .ag-header-cell {
  font-family: "Poppins", sans-serif !important;
}

/* =========================================
   2. Column Borders (FIXED)
   ========================================= */
/* Header Cells: Always have a right border */
.client-side-datatable .ag-header-cell {
  border-right: 1px solid #dde2eb !important;
}

/* Data Cells: Default gray border */
.client-side-datatable .ag-cell {
  border-right: 1px solid #dde2eb !important;
}

/* Focused Cells: Allow the Blue focus border to appear on the right */
.client-side-datatable .ag-cell.ag-cell-focus {
  border-right-color: var(
    --ag-range-selection-border-color,
    #2196f3
  ) !important;
}

/* FIX: If Header is Active, HIDE the body cell focus (reset it to gray) */
.client-side-datatable:has(.ag-header:focus-within) .ag-cell.ag-cell-focus {
  border-color: transparent !important;
  border-right: 1px solid #dde2eb !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Remove border from the very last column */
.client-side-datatable .ag-header-cell:last-child,
.client-side-datatable .ag-cell:last-child {
  border-right: none !important;
}

/* =========================================
   3. Header Styling & Layout
   ========================================= */
.client-side-datatable .ag-cell-label-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  width: auto !important;
}

.client-side-datatable .ag-header-cell-label {
  flex: 0 0 auto !important;
  width: auto !important;
}

.client-side-datatable .ag-header-cell-text {
  font-weight: 500 !important;
  padding-left: 10px !important;
}

/* =========================================
   4. Filter Button Styling
   ========================================= */
.client-side-datatable .ag-header-cell-filter-button {
  opacity: 1 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  order: 2;
  margin-left: 8px;
  margin-right: 0;
  height: auto !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.client-side-datatable .ag-header-cell-filter-button:hover,
.client-side-datatable .ag-header-cell-filter-button:active,
.client-side-datatable .ag-header-cell-filter-button:focus {
  background-color: transparent !important;
  opacity: 1 !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* =========================================
   5. Input Fields & Focus States
   ========================================= */
.client-side-datatable .ag-input-field-input:focus,
.client-side-datatable .ag-wrapper.ag-input-wrapper:focus-within,
.client-side-datatable .ag-input-wrapper:focus-within,
.client-side-datatable .ag-text-field-input-wrapper:focus-within,
.client-side-datatable .ag-picker-field-wrapper:focus,
.client-side-datatable .ag-picker-field-wrapper:focus-within {
  box-shadow: none !important;
  outline: none !important;
  border-color: #babfc7 !important;
}

/* =========================================
   6. Tooltip Styling
   ========================================= */
.ag-tooltip,
.ag-theme-alpine .ag-tooltip {
  background-color: #616161 !important;
  color: #fff !important;
  border-radius: 4px !important;
  padding: 8px 12px !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 13px !important;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
  border: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/agclient.css"],"names":[],"mappings":"AAAA;;8CAE8C;AAC9C;;EAEE,6CAA6C;AAC/C;;AAEA;;8CAE8C;AAC9C,6CAA6C;AAC7C;EACE,0CAA0C;AAC5C;;AAEA,oCAAoC;AACpC;EACE,0CAA0C;AAC5C;;AAEA,sEAAsE;AACtE;EACE;;;cAGY;AACd;;AAEA,0EAA0E;AAC1E;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;;EAEE,6BAA6B;AAC/B;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;8CAE8C;AAC9C;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;;EAGE,wCAAwC;EACxC,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;8CAE8C;AAC9C;;;;;;EAME,2BAA2B;EAC3B,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;8CAE8C;AAC9C;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,6CAA6C;EAC7C,0BAA0B;EAC1B;yFACuF;EACvF,uBAAuB;AACzB","sourcesContent":["/* =========================================\n   1. Typography & Base Settings\n   ========================================= */\n.client-side-datatable .ag-cell,\n.client-side-datatable .ag-header-cell {\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n/* =========================================\n   2. Column Borders (FIXED)\n   ========================================= */\n/* Header Cells: Always have a right border */\n.client-side-datatable .ag-header-cell {\n  border-right: 1px solid #dde2eb !important;\n}\n\n/* Data Cells: Default gray border */\n.client-side-datatable .ag-cell {\n  border-right: 1px solid #dde2eb !important;\n}\n\n/* Focused Cells: Allow the Blue focus border to appear on the right */\n.client-side-datatable .ag-cell.ag-cell-focus {\n  border-right-color: var(\n    --ag-range-selection-border-color,\n    #2196f3\n  ) !important;\n}\n\n/* FIX: If Header is Active, HIDE the body cell focus (reset it to gray) */\n.client-side-datatable:has(.ag-header:focus-within) .ag-cell.ag-cell-focus {\n  border-color: transparent !important;\n  border-right: 1px solid #dde2eb !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n/* Remove border from the very last column */\n.client-side-datatable .ag-header-cell:last-child,\n.client-side-datatable .ag-cell:last-child {\n  border-right: none !important;\n}\n\n/* =========================================\n   3. Header Styling & Layout\n   ========================================= */\n.client-side-datatable .ag-cell-label-container {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-start;\n  width: auto !important;\n}\n\n.client-side-datatable .ag-header-cell-label {\n  flex: 0 0 auto !important;\n  width: auto !important;\n}\n\n.client-side-datatable .ag-header-cell-text {\n  font-weight: 500 !important;\n  padding-left: 10px !important;\n}\n\n/* =========================================\n   4. Filter Button Styling\n   ========================================= */\n.client-side-datatable .ag-header-cell-filter-button {\n  opacity: 1 !important;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  order: 2;\n  margin-left: 8px;\n  margin-right: 0;\n  height: auto !important;\n  background-color: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n\n.client-side-datatable .ag-header-cell-filter-button:hover,\n.client-side-datatable .ag-header-cell-filter-button:active,\n.client-side-datatable .ag-header-cell-filter-button:focus {\n  background-color: transparent !important;\n  opacity: 1 !important;\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* =========================================\n   5. Input Fields & Focus States\n   ========================================= */\n.client-side-datatable .ag-input-field-input:focus,\n.client-side-datatable .ag-wrapper.ag-input-wrapper:focus-within,\n.client-side-datatable .ag-input-wrapper:focus-within,\n.client-side-datatable .ag-text-field-input-wrapper:focus-within,\n.client-side-datatable .ag-picker-field-wrapper:focus,\n.client-side-datatable .ag-picker-field-wrapper:focus-within {\n  box-shadow: none !important;\n  outline: none !important;\n  border-color: #babfc7 !important;\n}\n\n/* =========================================\n   6. Tooltip Styling\n   ========================================= */\n.ag-tooltip,\n.ag-theme-alpine .ag-tooltip {\n  background-color: #616161 !important;\n  color: #fff !important;\n  border-radius: 4px !important;\n  padding: 8px 12px !important;\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 13px !important;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;\n  border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
